import PropTypes from 'prop-types';

/**
 * PropTypes for the createUpdateContainerConfig.
 * @typedef {Object} createUpdateContainerConfigPropTypes
 * @property {Object} onGetResource - The object containing the setFields function.
 * @property {Object} onCreateResource - The object containing the setBody function.
 * @property {Object} onUpdateResource - The object containing the setBody function.
 */
export const createUpdateContainerConfigPropTypes = PropTypes.shape({
  onGetResource: PropTypes.shape({
    setFields: PropTypes.func
  }),
  onCreateResource: PropTypes.shape({
    setBody: PropTypes.func
  }),
  onUpdateResource: PropTypes.shape({
    setBody: PropTypes.func
  })
});
